import { render } from "./panelCharts.vue?vue&type=template&id=382ab606&scoped=true"
import script from "./panelCharts.vue?vue&type=script&lang=js"
export * from "./panelCharts.vue?vue&type=script&lang=js"

import "./panelCharts.vue?vue&type=style&index=0&id=382ab606&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382ab606"]])

export default __exports__